import React from 'react';
// Tips library removed — not used in program mode
const TipsLibrary = () => null;
export default TipsLibrary;
